<template>
    <div id="suggestion-manager-card" role="menubar" class="mb-2 card">
        <slot name="title" v-if="showTitle" >
            <div class="suggestion-manager-card-title card-header d-flex align-items-center suggestion-name p-2">
                <suggestion-title :use-light-variation="false" />
            </div>
        </slot>

        <div class="d-flex flex-wrap pb-1 pt-0 pt-sm-2 sidebar-section no-borders">
            <suggestion-manager-props />
        </div>
    </div>
</template>

<style lang="scss">
.suggestion-manager-card-title  {
    ////background: var(--bs-btn-bg);
    //border-radius: var(--border-radius);
    //border-bottom-right-radius: 0;
    //border-bottom-left-radius: 0;
    //border-color: rgba(0, 0, 0, 0.125);
    //border-width: 1px;
    //border-style: solid;
    //color: var(--dark-text-color);
}
</style>

<style lang="scss" scoped>
#suggestion-manager-card {
    .suggestion-name {
        font-size: var(--font-size-14);
    }


    // X-Large devices (large desktops, 1200px and up)
    @media (min-width: 1200px) {
        .suggestion-name {
            font-size: var(--font-size-16);
        }
    }
}
</style>


<script>
import {mapGetters} from "vuex";
import SuggestionManagerProps from "@/components/Suggestions/ManageSuggestion/SuggestionManagerProps";
import {getIconClass} from "../../../services/Icons";
import SuggestionTitle from "@/components/Suggestions/ManageSuggestion/SuggestionTitle";

export default {
    name: "SuggestionManager",
    data() {
        return {}
    },
    props: {
        showTitle: {type: Boolean, default: true},
    },
    components: {
        SuggestionManagerProps,
        SuggestionTitle,
    },
    computed: {
        ...mapGetters({
            currentCollection: 'currentCollection',
            topic: 'currentTopic',
            hasSuggestions: 'hasSuggestions',
            canManageCollection: 'canManageCollection',
            accountFeatures: 'accountFeatures',
            suggestionViewerType: 'suggestionViewerType',
        }),
        icon() {
            return this.suggestionViewerType === 'collections' ? getIconClass(this.currentCollection.icon || 'bolt') :
                'fa fa-search'
        },
        name() {
            if (this.suggestionViewerType === 'topics')
                return this.topic && this.topic.name
            else
                return this.currentCollection.name
        }
    },
    mounted() {

    },
    methods: {
        isCollectionSource(type) {
            /* Checks if the provided string can be a source for a collection. */
            /* If 'custom' source type is added, then it will need to be added below as well */
            return typeof type === 'string' && /rss|collection|topic/.test(type);
        },
    },

}
</script>
